// extracted by mini-css-extract-plugin
export default {"root":"Navbar_root__2XES1"};